import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
import store from "../store";
import api from "../request";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
NProgress.configure({
  easing: "ease", // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3, // 初始化时的最小百分比
});

//!运力监控大屏
//运力监控大屏
import Map from "@/views/map/map.vue";
//每日数据统计
import Daily from "@/views/daily.vue";
//!销售管理
//历史数据管理
import StatisticsHistory from "@/views/statistics/history.vue";
//发班数据管理
import StatisticsTransport from "@/views/statistics/transport.vue";
//线路列表
import PostLineList from "@/views/postline/list.vue";
//添加线路
import PostLineCreate from "@/views/postline/create.vue";
//项目计划
import projects from "@/views/projectmanage/projects.vue";
//!市场管理
//投资收益测算
import costcal from "@/views/projectmanage/costcal.vue";
//线路收益表
import linerevenue from "@/views/projectmanage/linerevenue.vue";
//线路时间表
import Schedule from "@/views/projectmanage/schedule.vue";
//日运行时间表
import OrdersCalc from "@/views/orders/calc.vue";
//周运行时间表
import OrdersCalcWeek from "@/views/orders/calcweek.vue";
//!运营管理
//任务派车管理
import DispatchPlan from "@/views/dispatchplan.vue";
//任务派车管理（新）
import DispatchPlan2 from "@/views/dispatch/index.vue";
//任务计划生成
import DispatchList from "@/views/dispatch/list.vue";
//路单管理
import OrdersList from "@/views/orders/list.vue";
//路单异常
import OrdersException from "@/views/orders/exception.vue";
//邮局管理
import PostOfficeList from "@/views/postoffice/list.vue";
//油价联动
import PostOfficeOilPrice from "@/views/postoffice/oilprice.vue";
//车辆比例系数
import PostOfficeCarratio from "@/views/postoffice/carratio.vue";
//调车价格统计
import FincanceSelfBillChart from "@/views/finance/selfbillchart.vue";
//结算账单管理
import SettleSummary from "@/views/settle/settle_summary.vue";
//结算账单明细
import SettleItems from "@/views/settle/settle_items.vue";
//!运力池管理
//车辆管理
import VehicleVehicle from "@/views/vehicle/vehicle.vue";
//司机管理
import CarrierDriver from "@/views/carrier/driver.vue";
//GPS设备管理
import VehicleGps from "@/views/vehicle/gps.vue";
//车辆使用情况
import RunningTable from "@/views/runningtable.vue";
//车辆里程统计
import StatisticsVehicleGps from "@/views/statistics/vehiclegps.vue";
//车辆能耗管理
import EnergyConsumption from "@/views/vehicle/energyconsumption.vue";
//车辆运行轨迹
import VehicleCar from "@/views/vehicle/car.vue";
//充电桩管理
import VehicleChargingPile from "@/views/vehicle/chargingpile.vue";
//充电数据管理
import Recharge from "@/views/vehicle/recharge.vue";
//ETC数据管理
import ETCList from "@/views/vehicle/etclist.vue";
//油卡数据管理
import FuelCard from "@/views/vehicle/fuelcard.vue";
//车队管理
import CarrierPartner from "@/views/carrier/partner.vue";
//车型管理
import VehicleList from "@/views/vehicle/provincevehicle.vue";
//车辆黑名单
import VehicleBlock from "@/views/vehicle/block.vue";
//!综合管理
//工作日志
import dailyrecord from "@/views/projectmanage/dailyrecord.vue";
//合同列表
import ContractList from "@/views/contract/list.vue";
//添加合同
import ContractAdd from "@/views/contract/add.vue";
//合同详情
import ContractInfo from "@/views/info.vue";
//消息管理
import ManageMessage from "@/views/manage/message.vue";
//!财务管理
//项目财务报表
import report from "@/views/projectmanage/report.vue";
//投标线路标的
import marketdata from "@/views/projectmanage/marketdata.vue";
//财务账单管理
import FincanceBill from "@/views/finance/financialbill.vue";
//财务账单（泌阳）
import BYFincanceBill from "@/views/finance/byfinancialbill.vue";
//资金利息成本
import ZijinCostInterest from "@/views/finance/zijincostinterest.vue";
//上有账单管理
import FincanceUpBill from "@/views/finance/upbill.vue";
//下游账单管理
import FincanceDownBill from "@/views/finance/downbill.vue";
//自营账单管理
import FincanceSelfBill from "@/views/finance/selfbill.vue";
//项目成本管理
import FincanceProjectBill from "@/views/finance/projectbill.vue";
//应收管理
import Receivable from "@/views/finance/receivable.vue";
//应收（泌阳）管理
import BYReceivable from "@/views/finance/byreceivable.vue";
//应付管理
import Payable from "@/views/finance/payable.vue";
//应付（自营）管理
import SelfPayable from "@/views/finance/selfpayable.vue";
//营收日报
import Managedaily from "@/views/finance/managedaily.vue";
//项目统计数据
import FincanceReport from "@/views/finance/report.vue";
//进项票管理
import IncomeBill from "@/views/finance/incomebill.vue";
//销项票管理
import OutputBill from "@/views/finance/outputbill.vue";
//!地图数据管理
//点位管理
import MapLocation from "@/views/map/location.vue";
//线路管理
import MapLine from "@/views/map/line.vue";
//!系统管理
//账号管理
import system_account from "@/views/system/account.vue";
//角色管理
import system_role from "@/views/system/role.vue";
//权限管理
import system_permission from "@/views/system/permission.vue";
//系统日志
import system_log from "@/views/system/log.vue";
//!个人中心
//账号设置
import user_setting from "@/views/user/setting.vue";
//!DEV
//路单抓取任务
import CptmcpTask from "@/views/cptmcp/task.vue";
//车管平台账号
import CptmcpAccount from "@/views/cptmcp/account.vue";
//车辆监控
import VehicleMonit from "@/views/dev/vehiclemonit.vue";
//刷新应收应付
import RefreshReceivePay from "@/views/dev/refreshreceivepay.vue";
//系统设置
import SystemSetting from "@/views/dev/setting.vue";

import ProvinceCarrierQualityData from "@/views/provincecarrierqualitydata.vue";
import QualityData from "@/views/qualitydata.vue";
import MPLogin from "@/views/MPLogin.vue";
import NotFound from "@/views/404.vue";

const routes = [
  { path: "/", redirect: "/map" },
  //运力监控大屏
  {
    path: "/map",
    component: Map,
    meta: { layout: "basic-layout", title: "运力监控大屏" },
  },
  //每日数据统计
  {
    path: "/daily",
    component: Daily,
    meta: { layout: "basic-layout", title: "每日数据统计" },
  },
  //!销售管理
  //历史数据管理
  {
    path: "/statistics/history",
    component: StatisticsHistory,
    meta: { layout: "basic-layout", title: "历史数据管理" },
  },
  //发班数据管理
  {
    path: "/statistics/transport",
    component: StatisticsTransport,
    meta: { layout: "basic-layout", title: "发班数据管理" },
  },
  //线路列表
  {
    path: "/postline/list",
    component: PostLineList,
    meta: { layout: "basic-layout", title: "线路列表" },
  },
  //添加线路
  {
    path: "/postline/create",
    component: PostLineCreate,
    meta: { layout: "basic-layout", title: "添加线路" },
  },
  //项目计划
  {
    path: "/projectmanage/projects",
    component: projects,
    meta: { layout: "basic-layout", title: "项目计划" },
  },
  //!市场管理
  //投资收益测算
  {
    path: "/projectmanage/costcal",
    component: costcal,
    meta: { layout: "basic-layout", title: "投资收益测算" },
  },
  //线路收益表
  {
    path: "/projectmanage/linerevenue",
    component: linerevenue,
    meta: { layout: "basic-layout", title: "线路收益表" },
  },
  //线路时间表
  {
    path: "/projectmanage/timecal",
    component: Schedule,
    meta: { layout: "basic-layout", title: "线路时间表" },
  },
  //日运行时间表
  {
    path: "/orders/calc",
    component: OrdersCalc,
    meta: { layout: "basic-layout", title: "日运行时间表" },
  },
  //周运行时间表
  {
    path: "/orders/calcweek",
    component: OrdersCalcWeek,
    meta: { layout: "basic-layout", title: "周运行时间表" },
  },
  //!运营管理
  //任务派车管理
  {
    path: "/dispatchplan",
    component: DispatchPlan,
    meta: { layout: "basic-layout", title: "任务派车管理" },
  },
  //任务派车管理(新)
  {
    path: "/dispatchplan2",
    component: DispatchPlan2,
    meta: { layout: "basic-layout", title: "任务派车管理(新)" },
  },
  //调度计划生成
  {
    path: "/dispatch/list",
    component: DispatchList,
    meta: { layout: "basic-layout", title: "调度计划生成" },
  },
  //路单管理
  {
    path: "/orders/list",
    component: OrdersList,
    meta: { layout: "basic-layout", title: "路单管理" },
  },
  //路单异常
  {
    path: "/orders/exception",
    component: OrdersException,
    meta: { layout: "basic-layout", title: "路单异常" },
  },
  //邮局管理
  {
    path: "/postoffice/list",
    component: PostOfficeList,
    meta: { layout: "basic-layout", title: "邮局管理" },
  },
  //油价联动
  {
    path: "/postoffice/oilprice",
    component: PostOfficeOilPrice,
    meta: { layout: "basic-layout", title: "油价联动" },
  },
  //车辆比例系数
  {
    path: "/postoffice/carratio",
    component: PostOfficeCarratio,
    meta: { layout: "basic-layout", title: "车辆比例系数" },
  },
  //调车价格统计
  {
    path: "/finance/selfbillchart",
    component: FincanceSelfBillChart,
    meta: { layout: "basic-layout", title: "调车价格统计" },
  },
  //结算账单管理
  {
    path: "/settle/summary",
    component: SettleSummary,
    meta: { layout: "basic-layout", title: "结算账单管理" },
  },
  //结算账单明细
  {
    path: "/settle/items",
    component: SettleItems,
    meta: { layout: "basic-layout", title: "结算账单明细" },
  },
  //!运力池管理
  //车辆管理
  {
    path: "/vehicle/vehicle",
    component: VehicleVehicle,
    meta: { layout: "basic-layout", title: "车辆管理" },
  },
  //司机管理
  {
    path: "/carrier/driver",
    component: CarrierDriver,
    meta: { layout: "basic-layout", title: "司机管理" },
  },
  //GPS设备管理
  {
    path: "/vehicle/gps",
    component: VehicleGps,
    meta: { layout: "basic-layout", title: "GPS设备管理" },
  },
  //车辆使用情况
  {
    path: "/runningtable",
    component: RunningTable,
    meta: { layout: "basic-layout", title: "车辆使用情况" },
  },
  //车辆里程统计
  {
    path: "/statisticsvehiclegps",
    component: StatisticsVehicleGps,
    meta: { layout: "basic-layout", title: "车辆里程统计" },
  },
  //车辆能耗管理
  {
    path: "/vehicle/energyconsumption",
    component: EnergyConsumption,
    meta: { layout: "basic-layout", title: "车辆能耗管理" },
  },
  //车辆运行轨迹
  {
    path: "/vehicle/car",
    component: VehicleCar,
    meta: { layout: "basic-layout", title: "车辆运行轨迹" },
  },
  //充电桩管理
  {
    path: "/vehicle/chargingpile",
    component: VehicleChargingPile,
    meta: { layout: "basic-layout", title: "充电桩管理" },
  },
  //充电数据管理
  {
    path: "/vehicle/recharge",
    component: Recharge,
    meta: { layout: "basic-layout", title: "充电数据管理" },
  },
  //ETC数据管理
  {
    path: "/vehicle/etc",
    component: ETCList,
    meta: { layout: "basic-layout", title: "ETC数据管理" },
  },
  //油卡数据管理
  {
    path: "/vehicle/fuelcard",
    component: FuelCard,
    meta: { layout: "basic-layout", title: "油卡数据管理" },
  },
  //车队管理
  {
    path: "/carrier/partner",
    component: CarrierPartner,
    meta: { layout: "basic-layout", title: "车队管理" },
  },
  //车型管理
  {
    path: "/vehicle/list",
    component: VehicleList,
    meta: { layout: "basic-layout", title: "车型管理" },
  },
  //车辆黑名单
  {
    path: "/vehicle/block",
    component: VehicleBlock,
    meta: { layout: "basic-layout", title: "车辆黑名单" },
  },
  //!综合管理
  //工作日志
  {
    path: "/projectmanage/dailyrecord",
    component: dailyrecord,
    meta: { layout: "basic-layout", title: "工作日志" },
  },
  //合同列表
  {
    path: "/contract/list",
    component: ContractList,
    meta: { layout: "basic-layout", title: "合同列表" },
  },
  //添加合同
  {
    path: "/contract/add",
    component: ContractAdd,
    meta: { layout: "basic-layout", title: "添加合同" },
  },
  //合同详情
  {
    path: "/contracts/:id?",
    component: ContractInfo,
    meta: { layout: "empty-layout", requireAuth: false, storeable: false },
  },
  //消息管理
  {
    path: "/manage/message",
    component: ManageMessage,
    meta: { layout: "basic-layout", title: "消息管理" },
  },
  //!财务管理
  //项目财务报表
  {
    path: "/projectmanage/report",
    component: report,
    meta: { layout: "basic-layout", title: "项目财务报表" },
  },
  //投标线路标的
  {
    path: "/projectmanage/marketdata",
    component: marketdata,
    meta: { layout: "basic-layout", title: "投标线路标的" },
  },
  //财务账单管理
  {
    path: "/finance/financialbill",
    component: FincanceBill,
    meta: { layout: "basic-layout", title: "财务账单管理" },
  },
  //财务账单(泌阳)
  {
    path: "/finance/byfinancialbill",
    component: BYFincanceBill,
    meta: { layout: "basic-layout", title: "财务账单(泌阳)" },
  },
  //资金成本利息
  {
    path: "/finance/zijincostinterest",
    component: ZijinCostInterest,
    meta: { layout: "basic-layout", title: "资金成本利息" },
  },
  //上游账单管理
  {
    path: "/finance/upbill",
    component: FincanceUpBill,
    meta: { layout: "basic-layout", title: "上游账单管理" },
  },
  //下游账单管理
  {
    path: "/finance/downbill",
    component: FincanceDownBill,
    meta: { layout: "basic-layout", title: "下游账单管理" },
  },
  //自营账单管理
  {
    path: "/finance/selfbill",
    component: FincanceSelfBill,
    meta: { layout: "basic-layout", title: "自营账单管理" },
  },
  //项目成本管理
  {
    path: "/finance/projectbill",
    component: FincanceProjectBill,
    meta: { layout: "basic-layout", title: "项目成本管理" },
  },
  //应收管理
  {
    path: "/finance/receivable",
    component: Receivable,
    meta: { layout: "basic-layout", title: "应收管理" },
  },
  //应收(泌阳)管理
  {
    path: "/finance/byreceivable",
    component: BYReceivable,
    meta: { layout: "basic-layout", title: "应收(泌阳)管理" },
  },
  //应付管理
  {
    path: "/finance/payable",
    component: Payable,
    meta: { layout: "basic-layout", title: "应付管理" },
  },
  //应付(自营)管理
  {
    path: "/finance/selfpayable",
    component: SelfPayable,
    meta: { layout: "basic-layout", title: "应付(自营)管理" },
  },
  //营收日报
  {
    path: "/finance/managedaily",
    component: Managedaily,
    meta: { layout: "basic-layout", title: "营收日报" },
  },
  //项目统计数据
  {
    path: "/finance/report",
    component: FincanceReport,
    meta: { layout: "basic-layout", title: "项目统计数据" },
  },
  //进项票管理
  {
    path: "/finance/incomebill",
    component: IncomeBill,
    meta: { layout: "basic-layout", title: "进项票管理" },
  },
  //销项票管理
  {
    path: "/finance/outputbill",
    component: OutputBill,
    meta: { layout: "basic-layout", title: "销项票管理" },
  },
  //!地图数据管理
  //点位管理
  {
    path: "/map/location",
    component: MapLocation,
    meta: { layout: "basic-layout", title: "点位管理" },
  },
  //线路管理
  {
    path: "/map/line",
    component: MapLine,
    meta: { layout: "basic-layout", title: "线路管理" },
  },
  //!系统管理
  //账号管理
  {
    path: "/system/account",
    component: system_account,
    meta: { layout: "basic-layout", title: "账号管理", storeable: false },
  },
  //角色管理
  {
    path: "/system/role",
    component: system_role,
    meta: { layout: "basic-layout", title: "角色管理", storeable: false },
  },
  //权限管理
  {
    path: "/system/permission",
    component: system_permission,
    meta: { layout: "basic-layout", title: "权限管理", storeable: false },
  },
  //系统日志
  {
    path: "/system/log",
    component: system_log,
    meta: { layout: "basic-layout", title: "系统日志", storeable: false },
  },
  //!个人中心
  //账号设置
  {
    path: "/user/setting",
    component: user_setting,
    meta: { layout: "basic-layout", title: "账号设置", storeable: false },
  },
  //!DEV
  //路单抓取任务
  {
    path: "/cptmcp/task",
    component: CptmcpTask,
    meta: { layout: "basic-layout", title: "路单抓取任务" },
  },
  //车管平台账号
  {
    path: "/cptmcp/account",
    component: CptmcpAccount,
    meta: { layout: "basic-layout", title: "车管平台账号" },
  },
  //车辆监控
  {
    path: "/dev/vehiclemonit",
    component: VehicleMonit,
    meta: { layout: "basic-layout", title: "车辆监控", storeable: false },
  },
  //刷新应收应付
  {
    path: "/dev/refreshreceivepay",
    component: RefreshReceivePay,
    meta: { layout: "basic-layout", title: "刷新应收应付" },
  },
  //系统设置
  {
    path: "/dev/setting",
    component: SystemSetting,
    meta: { layout: "basic-layout", title: "系统设置", storeable: false },
  },
  //登录
  {
    path: "/login",
    component: MPLogin,
    meta: { layout: "empty-layout", requireAuth: false, storeable: false },
  },
  //质量数据
  {
    path: "/qualitydata",
    component: QualityData,
    meta: { layout: "empty-layout", requireAuth: false, storeable: false },
  },
  {
    path: "/carrierqualitydata",
    component: ProvinceCarrierQualityData,
    meta: { layout: "empty-layout", requireAuth: false, storeable: false },
  },
  {
    path: "/provincecarrierqualitydata",
    component: ProvinceCarrierQualityData,
    meta: { layout: "empty-layout", requireAuth: false, storeable: false },
  },
  //404
  {
    path: "/404",
    component: NotFound,
    meta: { layout: "empty-layout", requireAuth: false, storeable: false },
  },
  { path: "*", redirect: "/404" },
];

const router = new Router({
  mode: "history",
  routes,
  base: "/",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) store.dispatch("SetNavTitle", to.meta.title);
  // console.log(to, from);
  store.dispatch("SetNavLogo", "");
  // 每次切换页面时，调用进度条
  NProgress.start();
  let v = localStorage.getItem("lidi.version") || "0";
  api.get(`/api/init?t=${Date.now()}&v=${v}`).then((data) => {
    // console.log(data);
    if (data.code === "newversion") {
      localStorage.setItem("lidi.version", data.version);
      NProgress.done();
      window.location.href = to.fullPath;
      return;
    }
    setTimeout(() => {
      let { userid, username, name, role, permissions, needlogin } = data;
      if (userid) {
        localStorage.setItem("lidi.userid", userid);
        store.dispatch("SetUserid", userid);
      }
      if (username) {
        localStorage.setItem("lidi.username", username);
        store.dispatch("SetUsername", username);
      }
      if (name) {
        localStorage.setItem("lidi.name", name);
        store.dispatch("SetName", name);
      }
      if (role) {
        localStorage.setItem("lidi.role", role);
        store.dispatch("SetRole", role);
      }
      if (permissions) {
        localStorage.setItem("lidi.permissions", JSON.stringify(permissions));
        store.dispatch("SetPermissions", permissions);
      }
      if (needlogin) localStorage.clear();
      if (!localStorage.getItem("lidi.token") && to.meta?.requireAuth !== false) {
        return next({ path: "/login" });
      }
      if (localStorage.getItem("lidi.token") && (to.path === "/login" || to.path === "/")) {
        return next({ path: "/daily" });
      }
      if (to.meta?.requireAuth !== false) {
        let authorized = store.getters.checkmenu(to.path, username, permissions);
        console.log(to.path, authorized, [
          authorized === true,
          typeof authorized === "string",
        ]);
        // next();
        if (authorized === true) next();
        else if (typeof authorized === "string") {
          if (authorized === to.path) next();
          else next({ path: authorized });
        }
        else next({ path: "/daily" });
        if (to.meta?.storeable !== false) {
          store.dispatch("OpenTab", {
            path: to.path,
            name: to.meta.title
          });
        }
      }
      else if (to.path === "/") {
        next({ path: "login" });
      }
      else {
        next();
        if (to.meta?.storeable !== false) {
          store.dispatch("OpenTab", {
            path: to.path,
            name: to.meta.title
          });
        }
      }
    }, 0);
  });
});
router.onError((error) => {
  if (error.message.includes('Redirected when going from')) {
    // Silently ignore redirection failures
    return;
  }
  console.error(error);
});
router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done();
});
window._doRouterPush = (path) => {
  if (router.currentRoute.path === path) return;
  router.push({ path }).catch(console.error);
};
window._doRouterReplace = (path) => {
  if (router.currentRoute.path === path) return;
  router.replace({ path }).catch(console.error);
};

export default router;
